import React, { Fragment, useEffect, useState, useMemo } from "react";
import { CCollapse, CLink } from "@coreui/react";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import axios from "axios";
import moment from "moment";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import {
  DELETE_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_ITEMS,
  AWS_IMAGE_FOLDER_BANNER,
} from "../../common/Constant";
import { uploadAWS } from "../../common/AWSHelper";
import { Link } from "react-router-dom";
import DeleteConfirmationModalBanner from "../Modal/DeleteConfirmation";
import { BsImages } from "react-icons/bs";
import { Noimage } from "../../common/imagePath";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button, MenuItem } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

function Banners({ visibleBannerChange, searchQuery }) {
  let deleteConfirmationPoupIdName = "DeleteBannerConfirmationModal";
  const [visibleBanners, setVisibleBanners] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchtext, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setPerPage] = useState(10);
  const [sortingId, setSortingId] = useState(6);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [bannerTypeDropdown, setBannerTypeDropdown] = useState();
  const [banner, setBanner] = useState(visibleBannerChange);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [changeImagename, setChangeImagename] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [ImageUrl, setImageUrl] = useState("");
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [selectedImage, setSelectedImage] = useState("");

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  // const [selectedRows, setSelectedRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const token = localStorage.getItem("Token");
  // Form Values
  const [formValues, setFormValues] = useState({
    Title: "",
    Description: "",
    ButtonTextName: "",
    ButtonLinkUrl: "",
    IsActive: "",
    OrderNumber: "",
    BannerType: "",
    ID: 0,
  });

  console.log(formValues.Title , "edit ID")
  // Form Values


  const handleListData = () => {
    setLoading(true);
    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
   

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    axios
      .get(
        `${
          config.ecommconfigBaseUrl
        }/ecomconfig/offerfindall?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
       
        setTableData(res.data.ResponseData);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
        // console.log()
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleListData();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);
  useEffect(() => {
    handleListData(1, perPageSize, searchtext, sortingId, sortingDirection);
    setLoading(true);
    axios
      .get(`${config.ecommconfigBaseUrl}/ecomconfig/bannertype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
       

        setBannerTypeDropdown(res.data.ResponseData);
        setLoading(false);
        // setFeaturedProducts(res.data.ResponseData);
        return res;
      });
  }, []);

 

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };
  //   Get all EcommConfig data

 

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ID).join(",");
    } else {
      data = id;
    }
    const deleteRequestParam = {
      ID: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };
  //HandleDelete

  //handle edit
  const handleEditBanner = (row) => {
    toastSuccess("You can Edit Banner");
 console.log(row , "kajsdcfbjksdcbn")
    setFormValues({
      ...formValues,
      Title: row.Title,
      Description: row.Description,
      ButtonTextName: row.ButtonTextName,
      ButtonLinkUrl: row.ButtonLinkUrl,
      IsActive: row.IsActive,
      OrderNumber: row.OrderNumber,
      BannerType: bannerTypeDropdown?.find((el) => el?.Type === row.BannerType)
        ?.ID,
      ImageUrl: row.ImageUrl,
      ID: row.ID,
    });
  };
  const resetform = () => {
    setFormValues({
      Title: "",
      Description: "",
      ButtonTextName: "",
      ButtonLinkUrl: "",
      IsActive: "",
      OrderNumber: "",
      BannerType: -1,
      ID: 0,
      ImageUrl: "",
    });
  };

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      size:"60",
    },
    {
      header: "Title",
      accessorKey: "Title",
    },
    {
      header: "Description",
      accessorKey: "Description",
    },
    {
      header: "Button Name",
      accessorKey: "ButtonTextName",
    },
    {
      header: "Link",
      accessorKey: "ButtonLinkUrl",
    },
    {
      header: "Banner Type",
      accessorKey: "BannerType",
    },
    {
      header: "IsActive",
      accessorKey: "IsActive", 
      size:"40",
    },
    {
      header: "Order Number",
      accessorKey: "OrderNumber",
      size:"90",
    },
    {
      header: "ImageUrl",
      accessorKey: "ImageUrl",
      cell: (row) => (
        <>
          {/* <Link to={row.original.ImageUrl} target="_blank"> */}
            <img
              // src={row.original.ImageUrl}
              alt="Selected Image"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage;
              }}
            />
          {/* </Link> */}
        </>
      ),
    },
  ]);

  //TableData Columns

  //HandleSubmit For the Form
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      // typeId: 1,
      ID: formValues.ID,
      Title: formValues.Title,
      Description: formValues.Description,
      ButtonTextName: formValues.ButtonTextName,
      ButtonLinkUrl: formValues.ButtonLinkUrl,
      IsActive: formValues.IsActive,
      OrderNumber: formValues.OrderNumber == "" ? 0 : formValues.OrderNumber,
      // BannerType: formValues.BannerType,
      BannerType: formValues.BannerType,
      ImageUrl: formValues.ImageUrl,
      LogInUserID: localStorage.getItem("ID"),
    };
   

    // return true;
    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/offerupsert`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // navigate("/suppliers");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Email" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        // setLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
      });
   
  };
 

  const vaidation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type, index) => {
  
    setBtnLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_BANNER, (data) => {
    
      if (data) {
        if (type === "Images") {
          setImageUrl(data);
       
          setFormValues({ ...formValues, ImageUrl: data });
          setLoading(false);
        }
      }
    });
  };

  //OnChange For Input Fields
  const handleChange = (event, fieldName) => {
  
    if (fieldName === "IsActive") {
      setFormValues({
        ...formValues,
        [fieldName]: event.target.checked ? 1 : 0,
      });
    } else {
      const { name, value } = event.target;
      setFormValues({ ...formValues, [name]: value });
    }
  };

  // Image Upload For multiple images

  const handleImageUpload = (event, index) => {
    setChangeImagename(true);

    if (vaidation(event.target.name, event?.currentTarget?.files[0])) {
    
      uploadFile(event?.currentTarget?.files[0], event.target.name, index);
    }

    const files = event.target.files;
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
          setPreviewImage(images);
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };

  //Data

  const data = [
    {
      name: "Title",
      input: (
        <>
          <input
            className="form-control form-control-sm"
            placeholder="Insert Title Of The Banner"
            name="Title"
            onChange={handleChange}
            value={formValues.Title}
          />
        </>
      ),
    },
    {
      name: "Description",
      input: (
        <>
          {" "}
          <input
            className="form-control form-control-sm"
            placeholder="Insert Description Of The Banner"
            name="Description"
            onChange={handleChange}
            value={formValues.Description}
          />
        </>
      ),
    },
    {
      name: "Button Name",
      input: (
        <>
          <input
            className="form-control form-control-sm"
            placeholder="Enter Button Name"
            name="ButtonTextName"
            onChange={handleChange}
            value={formValues.ButtonTextName}
          />
        </>
      ),
    },
    {
      name: "Link",
      input: (
        <>
          <input
            className="form-control form-control-sm"
            placeholder="Link To Redirect..."
            name="ButtonLinkUrl"
            onChange={handleChange}
            value={formValues.ButtonLinkUrl}
          />
        </>
      ),
    },
    {
      name: "Select Banner",
      input: (
        <>
          <select
            className="form-control form-control-sm"
            onChange={handleChange}
            name="BannerType"
            value={
              bannerTypeDropdown?.find(
                (el) => el?.ID === formValues?.BannerType
              )?.ID
            }
          >
            <option value={-1}>Select Banner Type</option>
            {bannerTypeDropdown?.map((option, index) => (
              <option key={index} value={option.ID} label={option.Type}>
                {/* {option.Name} */}
              </option>
            ))}
          </select>
        </>
      ),
    },
    {
      name: "Order Number",
      input: (
        <>
          {" "}
          <input
            type="number"
            className="form-control form-control-sm"
            placeholder="Choose Client Order"
            name="OrderNumber"
            onChange={handleChange}
            value={formValues.OrderNumber}
          />
        </>
      ),
    },
    {
      name: "IsActive",
      input: (
        <>
          <input
            // style={{ marginLeft: "-5rem" }}
            class="form-check-input"
            type="checkbox"
            id="flexSwitchCheckDefault"
            name="IsActive"
            onChange={(event) => handleChange(event, "IsActive")}
            checked={formValues.IsActive === 1}
          />
        </>
      ),
    },
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <Fragment>
      <Loader loading={loading} />
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">
              <CLink
               className="link"
                onClick={() => {
                  setVisibleBanners(!visibleBanners);
                  setBanner(!!banner);
                }}
              >
                Banners
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleBanners || visibleBannerChange}>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div
                  className="container"
                  style={{
                    textAlign: "center",
                    // backgroundColor: "blanchedalmond",
                    border: "1px solid rgba(0,0,0,.12)",
                  }}
                >
                  <div className="row mb-3 pt-3">
                    {/* <div className="col-md-10"> */}
                    <div className="row">
                      <div
                        // className="col-md-2"
                        style={{
                          width: "100%",
                          display: "grid",
                          gridTemplateColumns: "repeat(2,1fr)",
                          gap: "10px",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <label
                                  // className="mt-1 pull-left w-50"
                                  style={{ fontSize: "15px" }}
                                >
                                  {el.name}
                                </label>
                                <div
                                  className="col-md-10 text-left"
                                  style={{ width: "80%" }}
                                >
                                  {el.input}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  
                  </div>
               
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "1rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        height: "fit-content",
                        gap: "4rem",
                      }}
                    >
                      <h5 style={{ fontSize: "15px" }}>Image</h5>
                    
                      <input
                        type="file"
                        class="form-control form-control-sm"
                        id="inputGroupFile03"
                        accept="image/*"
                        aria-describedby="inputGroupFileAddon03"
                        multiple
                        onChange={handleImageUpload}
                        aria-label="Upload"
                        name="Images"
                      ></input>
                    </div>

                    
                    {formValues?.ImageUrl ? (
                      <div
                        className={`${
                          formValues?.ImageUrl
                            ? ""
                            : selectedImage
                            ? ""
                            : "d-none"
                        } form-group row`}
                      >
                        <img
                          src={`${
                            formValues?.ImageUrl
                              ? formValues?.ImageUrl
                              : selectedImage
                          }`}
                          alt="Item_Image"
                          className="ItemImage w-25 h-100"
                        />
                      </div>
                    ) : (
                      <div
                        className={`${
                          ImageUrl ? "" : selectedImage ? "" : "d-none"
                        } form-group row`}
                      >
                        <img
                          src={`${ImageUrl ? ImageUrl : selectedImage}`}
                          alt="Item_Image"
                          className="ItemImage w-25 h-100"
                        />
                      </div>
                    )}
                  </div>
                 
                  <div
                    style={{
                      gap: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <button type="submit" className="btn btn-sm btn-primary mb-3">
                      Submit
                    </button>

                    <div className="btn btn-sm btn-secondary mb-3" onClick={resetform}>
                      Reset
                    </div>
                  </div>
                </div>
              </form>
              <div
                className="table-responsive  mt-4"
                style={{ border: "1px solid rgba(0,0,0,.12)" }}
              >
               
                <MaterialReactTable
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  columns={columns}
                  data={tableData}
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowActions
                  enableColumnOrdering
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: rowCount },
                    sorting: [{ id: "state", desc: false }], //sort by state by default
                  }}
                
                  muiPaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300, 500],
                  }}
                  // manualFiltering
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                 
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem
                      className="confirm-text"
                      to="#"
                      // key="delete"
                      title="Delete"
                      data-bs-toggle="modal"
                      // data-bs-target="#DeleteConfirmationModal"
                      onClick={() => handleDeletePopup(row.original.ID, "", "")}
                    >
                      {/* <DeleteIcon /> */}
                      Delete
                    </MenuItem>,
                    <MenuItem
                      className="confirm-text"
                      to="#"
                      // key="delete"
                      title="Edit"
                      data-bs-toggle="modal"
                      // data-bs-target="#DeleteConfirmationModal"
                      onClick={() => handleEditBanner(row.original)}
                    >
                      {/* <DeleteIcon /> */}
                      Edit
                    </MenuItem>,
                  ]}
                  state={{
                    // columnFilters,
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
              </div>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleBanners(!visibleBanners);
                    setBanner(!!banner);
                  }}
                >
                  Banners
                </CLink>
              </h5>
            </div>
            <CCollapse visible={visibleBanners || visibleBannerChange}>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div
                    className="container"
                    style={{
                      textAlign: "center",
                      // backgroundColor: "blanchedalmond",
                      border: "1px solid rgba(0,0,0,.12)",
                    }}
                  >
                    <div className="row mb-3 pt-3">
                      {/* <div className="col-md-10"> */}
                      <div className="row">
                        <div
                          // className="col-md-2"
                          style={{
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            gap: "10px",
                          }}
                        >
                          {matchesSearchQuery &&
                            matchesSearchQuery?.map((el) => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <label
                                    className="mt-1 pull-left w-50"
                                    style={{ fontSize: "15px" }}
                                  >
                                    {el.name}
                                  </label>
                                  <div className="col-md-10 text-left">
                                    {el.input}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                      {/* </div> */}
                    </div>
                    {/* Button Name */}
                    {/* Image Upload */}
                    <div className="row mt-3">
                      <div className="col-md-1">
                        <h5
                          className="pull-left mt-1"
                          style={{ fontSize: "15px" }}
                        >
                          Image
                        </h5>
                      </div>
                      <div className="col-md-11">
                        <input
                          type="file"
                          class="form-control"
                          id="inputGroupFile03"
                          accept="image/*"
                          aria-describedby="inputGroupFileAddon03"
                          multiple
                          onChange={handleImageUpload}
                          aria-label="Upload"
                          name="Images"
                        ></input>
                      </div>
                    </div>
                    {/* Image Upload */}
                    {/* Image Show */}
                    <div className="row">
                      <div className="col-md-2"></div>
                      <div className="col-md-10">
                        <div
                          className={`${
                            ImageUrl ? "" : selectedImage ? "" : "d-none"
                          } form-group row`}
                        >
                          <label className="col-form-label col-md-2 form-label"></label>
                          <div className="col-md-10">
                            <img
                              src={`${ImageUrl ? ImageUrl : selectedImage}`}
                              alt="Item_Image"
                              className="ItemImage w-25 h-100"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Image Show */}
                    <div
                      style={{
                        gap: "10px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <button type="submit" className="btn btn-sm btn-primary mb-3">
                        Submit
                      </button>

                      <div className="btn btn-sm btn-primary mb-3" onClick={resetform}>
                        Reset
                      </div>
                    </div>
                  </div>
                </form>
                <div
                  className="table-responsive  mt-4"
                  style={{ border: "1px solid rgba(0,0,0,.12)" }}
                >
                  <DataTable
                    title="Banners"
                    columns={columns}
                    data={tableData}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    highlightOnHover
                    striped
                    responsive
                    paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                    fixedHeader
                    persistTableHead
                    sortServer
                    // selectableRows
                    onSort={handleSort}
                    onChangeRowsPerPage={(e) => {
                      handlePerRowsChange(1, e);
                    }}
                    onChangePage={handlePageChange}
                  />
                </div>
              </div>
            </CCollapse>
          </div>
        )
      )}

      <DeleteConfirmationModalBanner
        deleteApiUrl={`${config.ecommconfigBaseUrl}/ecomconfig/offerdelete`}
        // idname={deleteConfirmationPoupIdName}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </Fragment>
  );
}

export default Banners;
